

<app-chip
	*ngIf="status === 'pending'"
	[customClass]="isFull ? 'py-1 border-1' : 'p-1 lg:px-3 lg:py-[4px] border-1'"
	[bgColor]="isFull ? '#FFFFFF' : '#EEEDFE'"
>
	<div class="flex items-center gap-2">
		<mat-icon class="mdi mdi-clock-outline m-auto text-lg leading-5 w-4 h-4 text-[#5358E8]" [ngClass]="isFull ? '' : 'lg:hidden'" />
		<span class="text-no-wrap leading-4 text-sm text-[#5358E8]" [ngClass]="isFull ? 'block' : 'hidden lg:block'">Pendiente</span>
	</div>
</app-chip>

<!-- usado en listado de procesos -->
<app-chip
	*ngIf="status === 'in-progress'"
	[customClass]="isFull ? 'py-1 border-1' : 'p-1 lg:px-3 lg:py-[4px] border-1'"
	[bgColor]="isFull ? '#FFFFFF' : '#EEEDFE'"
>
	<div class="flex items-center gap-2">
		<mat-icon class="mdi mdi-clock-outline m-auto text-lg leading-5 w-4 h-4 text-[#5358E8]" [ngClass]="isFull ? '' : 'lg:hidden'" />
		<span class="text-no-wrap leading-4 text-sm text-[#5358E8]" [ngClass]="isFull ? 'block' : 'hidden lg:block'">{{label}}</span>
	</div>
</app-chip>

<app-chip
	*ngIf="status === 'running'"
	[customClass]="isFull ? 'py-1 border-1' : 'p-1 lg:px-3 lg:py-[4px] border-1'"
	[bgColor]="isFull ? '#FFFFFF' : '#EEEDFE'"
>
	<div class="flex items-center gap-2">
		<mat-icon class="mdi mdi-clock-outline m-auto text-lg leading-5 w-4 h-4 text-[#5358E8]" [ngClass]="isFull ? '' : 'lg:hidden'" />
		<span class="text-no-wrap leading-4 text-sm text-[#5358E8]" [ngClass]="isFull ? 'block' : 'hidden lg:block'">{{label}}</span>
	</div>
</app-chip>

<!-- usado en objetivos- api real -->
<app-chip
	*ngIf="status === 'sent'"
	[customClass]="isFull ? 'py-1 border-1' : 'p-1 lg:px-3 lg:py-[4px] border-1'"
	[bgColor]="isFull ? '#FFFFFF' : '#EEEDFE'"
>
	<div class="flex items-center gap-2">
    <mat-icon class="mdi mdi-clock-outline m-auto text-lg leading-5 w-4 h-4 text-[#5358E8]" [ngClass]="isFull ? '' : 'lg:hidden'" />
		<span class="text-no-wrap leading-4 text-sm text-[#5358E8]" [ngClass]="isFull ? 'block' : 'hidden lg:block'">{{label}}</span>
	</div>
</app-chip>

<app-chip
	*ngIf="status === 'rejected'"
	[customClass]="isFull ? 'py-1 border-1' : 'p-1 lg:px-3 lg:py-[4px] border-1'"
	[bgColor]="isFull ? '#FFFFFF' : '#FEF3C7'"
>
	<div class="flex items-center gap-2">
		<ion-icon name="alert-circle" class="text-lg m-auto leading-5 w-4 h-4 text-[#92400E]" [ngClass]="isFull ? '' : 'lg:hidden'"></ion-icon>
		<span class="text-no-wrap leading-4 text-sm text-[#92400E]" [ngClass]="isFull ? 'block' : 'hidden lg:block'">Rechazado</span>
	</div>
</app-chip>

 <app-chip
	*ngIf="status === 'approved'"
	[customClass]="isFull ? 'py-1 border-1' : 'p-1 lg:px-3 lg:py-[4px] border-1'"
	[bgColor]="isFull ? '#FFFFFF' : '#00e3961f'"
>
	<div class="flex items-center gap-2">
    <ion-icon name="checkmark-circle" class="text-lg m-auto leading-5 w-4 h-4 text-[#00e396]" [ngClass]="isFull ? '' : 'lg:hidden'"></ion-icon>
		<span class="text-no-wrap leading-4 text-sm text-[#00e396]" [ngClass]="isFull ? 'block' : 'hidden lg:block'">Aprobado</span>
	</div>
</app-chip>

 <app-chip
	*ngIf="status === 'draft'"
	[customClass]="isFull ? 'py-1 border-1' : 'p-1 lg:px-3 lg:py-[4px] border-1'"
	[bgColor]="isFull ? '#FFFFFF' : '#a5bee6'"
>
	<div class="flex items-center gap-2">
    <ion-icon name="checkmark-circle" class="text-lg m-auto leading-5 w-4 h-4 text-[#347aeb]" [ngClass]="isFull ? '' : 'lg:hidden'"></ion-icon>
		<span class="text-no-wrap leading-4 text-sm text-[#347aeb]" [ngClass]="isFull ? 'block' : 'hidden lg:block'">Aprobado</span>
	</div>
</app-chip>

